<template>
    <div>
        <el-dialog
            title=""
            :visible.sync="isreset"
            width="70%"
            :before-close="handleClosePassword" center>
        <div class="login-page">
        <div class="login_left">
            <div class="login-title-welcom">
                欢迎使用酝智期刊查询系统
            </div>
            <div id="index-title-wey">
                <div class="el-tabs el-tabs--top">
                    <div class="el-tabs__header is-top">
                        <div class="el-tabs__nav-wrap is-top">
                            <div class="el-tabs__nav-scroll">
                                <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
                                   
                                    <!-- <div id="tab-first" aria-controls="pane-first" role="tab" aria-selected="true" @click="loginSwitch(1)" class="el-tabs__item is-top" :class="tabIndex==1?'is-active':''">
                                        微信登录
                                    </div> -->
                                    <div id="tab-second" aria-controls="pane-second" role="tab"   class="el-tabs__item is-top is-active">
                                        修改密码
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-tabs__content">
                        <!-- <div role="tabpanel" id="pane-first" aria-labelledby="tab-first" class="el-tab-pane"  v-if="tabIndex == 1">
                            <div id="login_container">
                                <iframe src="https://open.weixin.qq.com/connect/qrconnect?appid=wxd149da94feb504e2&amp;scope=snsapi_login&amp;redirect_uri=https%3a%2f%2fqikan.lishushu51.com%2fwechatlogin&amp;state=STATE&amp;login_type=jssdk&amp;self_redirect=false&amp;styletype=&amp;sizetype=&amp;bgcolor=&amp;rst=&amp;href=data:text/css;charset=utf-8;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE1MHB4O21hcmdpbi10b3A6IDBweDt9LmltcG93ZXJCb3ggLnRpdGxlIHttYXJnaW4tYm90dG9tOiAyMHB4fS5pbXBvd2VyQm94IC5pbmZvIHt3aWR0aDogMjAwcHg7fQ==" frameborder="0" scrolling="no" width="300px" height="400px"></iframe>
                            </div>
                        </div> -->
                        <div role="tabpanel" aria-hidden="true" id="pane-second" aria-labelledby="tab-second" class="el-tab-pane">
                            <div id="login-form">
                                <form class="el-form">
                                    <div class="el-form-item">
                                        <label class="el-form-item__label" style="width: 80px;">电话号码</label>
                                        <div class="el-form-item__content" style="margin-left: 80px;">
                                            <div class="el-input" style="display:flex">
                                                <input type="text" v-model="form.phone" autocomplete="off" placeholder="请输入电话号码" class="el-input__inner input-phone">
                                                <!-- <div id="button" v-if="!timer" @click="getCode">获取验证码</div>
                                                <div v-if="timer" class="timer">{{time}}</div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="el-form-item">
                                        <label for="pass" class="el-form-item__label" style="width: 80px;">验证码</label>
                                        <div class="el-form-item__content" style="margin-left: 80px;">
                                            <div class="el-input">
                                                <input type="text" v-model="form.code" autocomplete="off" placeholder="请输入短信验证码" class="el-input__inner">
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="el-form-item">
                                        <label for="pass" class="el-form-item__label" style="width: 80px;">旧密码</label>
                                        <div class="el-form-item__content" style="margin-left: 80px;">
                                            <div class="el-input">
                                                <!----><input type="password" v-model="form.password" autocomplete="off" placeholder="请输入登录密码" class="el-input__inner"><!----><!----><!----><!---->
                                            </div><!---->
                                        </div>
                                    </div>
                                    <div class="el-form-item">
                                        <label for="pass" class="el-form-item__label" style="width: 80px;">新密码</label>
                                        <div class="el-form-item__content" style="margin-left: 80px;">
                                            <div class="el-input">
                                                <!----><input type="password" v-model="form.repassword" autocomplete="off" placeholder="请输入新密码" class="el-input__inner"><!----><!----><!----><!---->
                                            </div><!---->
                                        </div>
                                    </div>
                                    <div class="el-form-item">
                                        <label for="pass" class="el-form-item__label" style="width: 80px;">新密码</label>
                                        <div class="el-form-item__content" style="margin-left: 80px;">
                                            <div class="el-input">
                                                <!----><input type="password" v-model="form.repassword2" autocomplete="off" placeholder="请再次输入新密码" class="el-input__inner"><!----><!----><!----><!---->
                                            </div><!---->
                                        </div>
                                    </div>
                                    <button type="button" @click="submit()" class="el-button el-button--primary"><!----><!----><span>修改密码</span></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="login_right"><div id="close" class="close"></div></div>
        </div>
        </el-dialog>
    </div>
    
    
</template>

<script>
import $H from "@/common/request.js"
export default {
  name: 'password',
  props:{
    isreset:{ 
        type:Boolean,
        default:false,
    },
  },
  data() {
      return {
          tabIndex:2,
          form:{
              name:'',
              phone:'',
              password:'',
              repassword:'',
              repassword2:'',
              code:''
          },
        //   session_id:'',
        //   time:60,
        //   timer:false,
      }
  },
  methods:{
      handleClosePassword(){
          this.$emit('passwordVisible',false)
      },
      repassword(){
          this.$emit('repassword')
      },
      submit(){
            
            if(this.form.phone.length == 0 ){
                this.$message.error('请输入手机号码');
                return;
            }
            if(this.form.password.length == 0 ){
                this.$message.error('请输入旧密码');
                return;
            }
            if(this.form.password.length == 0 ){
                this.$message.error('请输入新密码');
                return;
            }
            if(this.form.repassword != this.form.repassword2 ){
                this.$message.error('两次输入的新密码不一致');
                return;
            }
            let user = localStorage.getItem('loginUser')
            user = JSON.parse(user);
            let header = {
                    headers:{
                        'Authorization': 'Bearer ' + user.access_token,
                    }
                 }
            $H.post('/user/verification',{old_password:this.form.password,new_password:this.form.repassword},header).then(res=>{
                this.$message({
                message: '修改成功',
                center: true
                });
                this.repassword();
            })
          
      },
    //   getCode(){
    //         if(this.form.name.length == 0 ){
    //               this.$message.error('请输入用户名');
    //               return;
    //           }
    //           if(this.form.phone.length == 0 ){
    //               this.$message.error('请输入手机号码');
    //               return;
    //           }
    //           if(this.form.password.length == 0 ){
    //               this.$message.error('请输入登陆密码');
    //               return;
    //           }
    //           if(this.form.password != this.form.repassword){
    //               this.$message.error('两次输入的密码不一致');
    //               return;
    //           }
    //           let that = this;
    //           $H.post('/user/register',{name:this.form.name,phone:this.form.phone,password:this.form.password}).then(res=>{
    //                 this.session_id = res.session_id
    //                 console.log(this.session_id)
    //                 that.timer = true;
    //                 that.time = 60;
    //                 let timmer = setInterval(function(){
    //                     if(that.time>0){
    //                         that.time--;
    //                     }else{
    //                         clearInterval(timmer)
    //                         that.timer = false;
    //                     }
                        
    //                 },1000)
                  
    //           })
    //   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-page{
    display: flex;
}
.login_left {
      flex: 1;
      width: 50%;
      height: 610px;
      overflow: hidden;
    }

    .login_left div {
      font-size: 16px;
      color: rgba(56, 56, 56, 1);
      font-family: SourceHanSansSC;
      text-align: center;
      margin: 20px auto
    }

    .login_right {
      flex:1;
      width: 50%;
      height: 610px;
      overflow: hidden;
      cursor: pointer;
      background: url(../../common/style/img/login1.png) no-repeat center;

    }
    .login_right .close{
      text-align: right;

      /* height: 50px;
      line-height: 60px;
      padding-right:20px; */
    }
    .close{
      /* float: right; */
      /* height: 50px; */
    }
    .close {
      text-align:center
    }
    .close img {
      vertical-align:middle
    }
    .close .iblock {
      display:inline-block;
      height:100%;
      width:0;
      vertical-align:middle
    }
    #index-title-wey div{
      margin-left: 0 ;
      margin-top: 0;
      margin-bottom: 1%;
      margin-right: 0;

    }
    #index-title-wey{
      width: 68%;
    }
    .el-tabs /deep/ .el-tabs__nav-wrap::after {

    background-color: none !important;
    }
    .el-tabs__nav-wrap::after {

        background-color:white;
    }
    #tab-first{
      margin-left:52% !important;
    }
    #tab-second{
      /* margin-left: 10% !important; */
    }
    .el-tabs__active-bar{
      margin-left: 52% !important;
    }
    #login-form{
      margin-top: 10% !important;
    }
    .el-form-item {
      margin-bottom: 10px !important;
    }
    .el-button--primary {
      color: #FCFCFC;
      width: 34%;
      border-radius: 50px;
      background: #4CADD3;
      border: none;
      margin-top: 1%;
    }
    .login-title-welcom{
      margin-top: 3% !important;
      font-size: 24px !IMPORTANT;
      font-family: PingFang-SC-Bold;
      color: #4CADD3 !IMPORTANT;
    }
    .el-tabs__item.is-active{
      color: #4CADD3 !important;

    }

    .el-tabs__active-bar{
      background-color:#4CADD3 !important ;
    }
    .el-tabs__item:hover{
      color: #4CADD3 !important;
      text-decoration: none;
    }
    .el-button:focus, .el-button:hover{
      color: white !important;
      border-color:  #4CADD3 !important;
      background-color:  #4CADD3 !important;
    }
    iframe{
      height:260px;
    }
    [v-cloak]{
            display: none
    }
    #button{
        width: 176px;
        background: #409EFF;
        border-radius: 6px;
        margin-left: 15px;
        padding: 0px 5px;
        cursor: pointer;
        color: #fff;
    }
    .timer{
        width: 35px;
        background-color: #999999;
		color: white;
		padding: 0px 5px;
		border-radius: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/Password.vue